import { Group, Camera, Vector3 } from "three";
// NOTE: This was created on 29/08/2020
// It might get outdated given how WebXR is still a work in progress
/**
 * VR manager for VR related operations.
 */
var VRManager = /** @class */ (function () {
    function VRManager() {
        var _this = this;
        /** Currently active VR session. */
        this.currentVRSession = null;
        /**
         * Callback for when the VR session is started.
         * @param session The VR session.
         */
        this.onVRSessionStarted = function (session) {
            session.addEventListener('end', _this.onVRSessionEnded);
            _this.renderer.xr.setSession(session);
            _this.currentVRSession = session;
        };
        /**
         * Callback when the VR session ends.
         */
        this.onVRSessionEnded = function () {
            var _a, _b;
            (_a = _this.currentVRSession) === null || _a === void 0 ? void 0 : _a.removeEventListener('end', _this.onVRSessionEnded);
            _this.currentVRSession = null;
            (_b = _this.onSessionEnded) === null || _b === void 0 ? void 0 : _b.call(_this);
        };
    }
    /**
     * Set and configure the VR session.
     * @param renderer Renderer to set the VR session for.
     * @param onSessionEnded Callback to call when the VR session ends.
     */
    VRManager.prototype.setVRSession = function (renderer, onSessionEnded) {
        var _a, _b, _c;
        this.renderer = renderer;
        this.onSessionEnded = onSessionEnded;
        if ((_a = navigator) === null || _a === void 0 ? void 0 : _a.xr) {
            var sessionInit = {
                optionalFeatures: ['local-floor', 'bounded-floor', 'hand-tracking']
            };
            (_c = (_b = navigator) === null || _b === void 0 ? void 0 : _b.xr) === null || _c === void 0 ? void 0 : _c.requestSession(VRManager.SESSION_TYPE, sessionInit).then(this.onVRSessionStarted);
            this.setupVRControls();
        }
    };
    /**
     * End the current VR session.
     */
    VRManager.prototype.endVRSession = function () {
        var _a;
        (_a = this.currentVRSession) === null || _a === void 0 ? void 0 : _a.end();
    };
    /**
     * Get the group containing the camera for VR.
     * VR camera works by adding a Group with Camera to the scene.
     * @param camera Camera which is to be cloned for VR use.
     */
    VRManager.prototype.getCameraGroup = function (camera) {
        // Set up the camera position in the VR - Adding a group with camera does it
        if (!this.cameraGroup) {
            this.cameraGroup = new Group();
        }
        if (camera) {
            this.vrCamera = new Camera().copy(camera);
            this.vrCamera.name = 'VR_CAMERA';
            this.vrCamera.far = 1000000;
            this.cameraGroup.position.copy(this.vrCamera.position);
            this.cameraGroup.add(this.vrCamera);
        }
        return this.cameraGroup;
    };
    /**
     * Get the camera used by VR.
     * @returns The camera used by VR.
     */
    VRManager.prototype.getVRCamera = function () {
        return this.vrCamera;
    };
    /**
     * Set up VR controls for moving around the event display.
     */
    VRManager.prototype.setupVRControls = function () {
        var _this = this;
        // Distance for a single step
        var stepDistance = 30;
        // Unit vector in camera direction
        var direction = new Vector3();
        // Interval ID for the movement interval
        var intervalId;
        // Get the controller
        this.controller = this.renderer.xr.getController(0);
        this.controller.addEventListener('selectstart', function () {
            // Start movement in camera direction
            intervalId = setInterval(function () {
                _this.moveInDirection(direction, stepDistance);
            }, 20);
        });
        this.controller.addEventListener('selectend', function () {
            // Stop the movement
            clearInterval(intervalId);
        });
    };
    /**
     * Move the camera in the given direction.
     * @param direction Direction to move towards.
     * @param stepDistance Distance to move by.
     */
    VRManager.prototype.moveInDirection = function (direction, stepDistance) {
        // Get the direction the controller is facing
        //! this.controller.getWorldDirection(direction);
        var _a;
        // Get direction the camera is facing
        (_a = this.renderer.xr.getCamera(new Camera())) === null || _a === void 0 ? void 0 : _a.getWorldDirection(direction);
        // Move the camera in the given direction
        this.cameraGroup.position.addScaledVector(direction, stepDistance);
        this.vrCamera.position.addScaledVector(direction, stepDistance);
    };
    /** Session type to use for VR. */
    VRManager.SESSION_TYPE = 'immersive-vr';
    return VRManager;
}());
export { VRManager };
//# sourceMappingURL=vr-manager.js.map